//*Dropzone.js*//

import React from 'react';
import { useDropzone } from 'react-dropzone';
import styled, { css } from 'styled-components';
import GalleryAddIcon from '../svgIcons/GalleryAddIcon';
import StyledText from '../styledComponents/StyledText';

const Dropzone = ({ onDrop, label, content, isinvalid, size, accept }) => {
  const { getRootProps, getInputProps } = useDropzone({
    accept: accept
      ? accept
      : {
          'image/jpeg': ['.jpg', '.jpeg'], // Allow .jpg and .jpeg files
          'image/png': ['.png'], // Allow .png files
          'image/webp': ['.webp'],
          'image/avif': ['.avif']
        },
    onDrop,
  });

  return (
    <div {...getRootProps({ className: 'dropzone' })}>
      <input className="input-zone" {...getInputProps()} />
      <div className={`text-center `}>
        <StyledResumeContainer
          className={` ${isinvalid ? 'border-danger' : ''}`}
          size={size}
        >
          <div className="d-flex flex-column align-items-center upload-icon-text">
            <StyledText color="icon">
              <GalleryAddIcon />
            </StyledText>
            <label className="mt-2">{label}</label>
            {content}
          </div>
        </StyledResumeContainer>
      </div>
    </div>
  );
};

const StyledResumeContainer = styled.div`
  border: 1.5px dashed ${({ theme }) => theme.dark50};
  background-color: ${({ theme }) => theme.dark95};
  display: flex;
  justify-content: center;
  gap: 8px;
  height: auto;
  border-radius: 4px;
  cursor: pointer;
  padding: ${({ size }) => (size === 'small' ? '5px' : '56px')};
  .upload-icon-text {
    border: 1.5px dashed ${({ theme }) => theme.dark50};
    padding: 16px;
    margin: 16px;
    border-radius: 4px;
    font-family: ${({ theme }) => theme.fontFamily};
    font-size: 16px;
    font-weight: 500;
    letter-spacing: 0.20000000298023224px;
    text-align: center;
  }
  ${({ theme }) => css`
    @media (max-width: ${theme?.breakpoints?.md}px) {
      padding: 30px;
    }
  `}
`;

export default Dropzone;
